import { Component, QueryList, ContentChildren, AfterViewInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { BcitiTabComponent } from './tab/tab.component';

@Component({
    selector: 'app-bciti-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
})
export class BcitiTabsComponent implements AfterViewInit, OnDestroy {
    @ContentChildren(BcitiTabComponent) tabs: QueryList<BcitiTabComponent>;

    @Input() reverseDirection = false;

    @Input() badges: boolean[];

    private tabsChangeSub: Subscription;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        this.selectFirstIfNoneActive();

        this.tabsChangeSub = this.tabs.changes.subscribe(() => {
            this.selectFirstIfNoneActive();
        });
    }

    ngOnDestroy(): void {
        this.tabsChangeSub?.unsubscribe();
    }

    private selectFirstIfNoneActive(): void {
        const activeTabs = this.tabs.filter((tab) => tab.active);
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
    }

    selectTab(tab: BcitiTabComponent): void {
        this.tabs.toArray().forEach((tabFromArray) => (tabFromArray.active = false));
        if (tab) {
            tab.active = true;
        }
        this.cdr.detectChanges();
    }
}
